import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { ActionButton, AntdRadioButton, Filters, RadioOptions } from "./styles";
import { Space, Dropdown, Menu, Modal, Radio, Tag } from "antd";
import {
	CloseCircleOutlined,
	PlusOutlined,
	InfoCircleOutlined,
} from "@ant-design/icons";
import Main from "../../../../layout/main/Main";
import { COLORS, Typo } from "../../../../layout/theme";
import DataTable from "../../../../common/data-table/DataTable";
import SignInTemplate from "../../../../layout/sign-in-template/SignInTemplate";
import DropShadow from "../../../../common/drop-shadow/DropShadow";
import { BsThreeDotsVertical } from "react-icons/bs";
import LoadingHeader from "./components/LoadingHeader";
import { useAuth } from "../../../../../contexts/authContext";
import {
	get_laboratory_suggestion_header_info,
	get_laboratory_suggestions_page,
	update_laboratory_suggestion_state,
} from "../../../../../api/endpoints/laboratorySuggestions";
import PrimaryButton from "../../../../common/antd-buttons/PrimaryButton";

const { confirm } = Modal;

export default function LaboratorySuggestionList() {
	const navigate = useNavigate();
	const { userdata } = useAuth();
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");
	const [data, setData] = useState(null);
	const [state, setState] = useState("ACTIVE");
	const [headerInfo, setHeaderInfo] = useState(null);
	const [key, setKey] = useState("null");

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const columns = [
		{
			title: () => <div style={{ color: COLORS.White }}>Cliente</div>,
			dataIndex: "laboratoryName",
			render: (value, record) => (
				<Link
					to={`/admin/laboratorySuggestions/${key.id}?uri=${uri}`}
					onMouseOver={() => setKey(record)}
				>
					<Typo type="secondary" fontWeight={600} fontSize={14}>
						{value}
					</Typo>
				</Link>
			),
		},
		{
			title: "",
			key: "id",
			dataIndex: "id",
			width: 10,
			render: (f, r, i) => (
				<>
					<Dropdown
						overlay={!r.deleted ? menu : menuInactive}
						placement="bottomRight"
					>
						<ActionButton key={`${f}`} onMouseOver={() => setKey(f)}>
							<BsThreeDotsVertical />
						</ActionButton>
					</Dropdown>
				</>
			),
		},
	];

	const menu = (
		<Menu
			items={[
				{
					key: "1",
					label: (
						<Link to={`/admin/laboratorySuggestions/${key}?uri=${uri}`}>
							<Typo type="secondary">Editar</Typo>
						</Link>
					),
				},
				{
					key: "2",
					label: <Typo onClick={() => handleDelete(key)}>Borrar</Typo>,
				},
			]}
		/>
	);

	const menuInactive = (
		<Menu
			items={[
				{
					key: "1",
					label: (
						<Link to={`/admin/laboratorySuggestions/${key}?uri=${uri}`}>
							<Typo type="secondary">Editar</Typo>
						</Link>
					),
				},
				{
					key: "2",
					label: <Typo onClick={() => handleActivate(key)}>Habilitar</Typo>,
				},
			]}
		/>
	);

	const fetch_data_laboratory_suggestions = async (page, search) => {
		const res = await get_laboratory_suggestions_page(search, state, page);
		setData(res);
	};

	useEffect(() => {
		fetch_data_laboratory_suggestions(1, "");
	}, [state]);

	const fetch_laboratory_suggestions_header = async (search) => {
		const res = await get_laboratory_suggestion_header_info(search);
		setHeaderInfo(res);
	};

	useEffect(() => {
		fetch_laboratory_suggestions_header();
	}, [state]);

	const handleDelete = (key) => {
		confirm({
			title: "¿Seguro que quiere eliminar esta configuracion?",
			icon: <CloseCircleOutlined style={{ color: "red" }} />,
			content: "La configuracion de sugeridos será eliminada al aceptar",
			okText: "Sí",
			okType: "danger",
			cancelText: "No",
			onOk: () => {
				deleteActiveIngredient(key);
			},
		});
	};

	const deleteActiveIngredient = async (id) => {
		const _state = { id: id, state: "DELETED" };
		await update_laboratory_suggestion_state(id, _state);
		fetch_data_laboratory_suggestions(1, "");
		fetch_laboratory_suggestions_header();
	};

	const handleActivate = (key) => {
		confirm({
			title: "¿Seguro que quiere activar esta configuracion?",
			icon: <InfoCircleOutlined style={{ color: "blue" }} />,
			content: "La configuracion de sugeridos será reactivada al aceptar",
			okText: "Sí",
			okType: "danger",
			cancelText: "No",
			onOk: () => {
				activateActiveIngredient(key);
			},
		});
	};

	const activateActiveIngredient = async (id) => {
		const _state = { id: id, state: "ACTIVATED" };
		await update_laboratory_suggestion_state(id, _state);
		fetch_data_laboratory_suggestions(1, "");
		fetch_laboratory_suggestions_header();
	};

	return (
		<Main>
			<Main.Breadcrumb>
				<Main.BreadcrumbItem>
					{uri ? (
						<Link to={"/" + uri}>Configuración General</Link>
					) : (
						<Link to="/">Home</Link>
					)}
				</Main.BreadcrumbItem>
				<Main.BreadcrumbSeparator />
				<Main.ActiveBreadcrumbItem>
					Listado de configuraciones
				</Main.ActiveBreadcrumbItem>
			</Main.Breadcrumb>

			<Main.Body>
				<Filters>
					<RadioOptions>
						<Radio.Group
							value={state}
							onChange={(e) => setState(e.target.value)}
						>
							<AntdRadioButton value="ACTIVE">
								Activo ({headerInfo?.totalActive})
							</AntdRadioButton>
							<AntdRadioButton value="DELETED">
								Inactivo ({headerInfo?.totalDisabled})
							</AntdRadioButton>
						</Radio.Group>
					</RadioOptions>
					{userdata.isOneMarket && (
						<PrimaryButton
							type="primary"
							bg="Primary"
							color="White"
							icon={<PlusOutlined />}
							onClick={() =>
								navigate("/admin/laboratorySuggestions/create?uri=" + uri)
							}
							style={{ width: "200px", fontWeight: "400" }}
						>
							Crear Configuracion
						</PrimaryButton>
					)}
				</Filters>

				<DataTable
					data={data}
					fetch={fetch_data_laboratory_suggestions}
					columns={columns}
					containerMarginTop={"0px"}
				/>
			</Main.Body>
		</Main>
	);
}
